module.exports = __webpack_public_path__ + "media/lsl.0b0c2de4.mp3";